<template>
  <div id="user-data">
    <vx-card :title="titleCard" class="mb-base">
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2">
          <div>
            <!-- Compañía -->
            <div>
              <label class="text-sm ">Compañía</label>
              <v-select v-model="casoCompaniaId" name="casoCompaniaId" label="id" class="w-full mt-1 mb-3"
                :options="companiasList" :reduce="item => item.id" :disabled="this.companiasActive"
                @input="handleCompania" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoCompaniaId') || formerr.includes('casoCompaniaId')">
                Por favor seleccione la compañía
              </span>
            </div>

            <!-- Asunto -->
            <div v-show="projectIdAddDataList.includes('67')">
              <vs-input class="w-full mt-3 mb-3" label="Asunto" v-model="casoAsunto" v-validate="'required'"
                name="casoAsunto" />
              <span class="text-danger text-sm" v-show="errors.has('casoAsunto') || formerr.includes('casoAsunto')
                ">Por favor ingrese el asunto</span>
            </div>

            <!-- Descripción -->
            <div class="w-full mt-3 mb-3">
              <label for="casoDescripcion" class="vs-input--label">Descripción</label>
              <vs-textarea class="w-full mb-0" v-model="casoDescripcion" v-validate="'required'"
                name="casoDescripcion" />
              <span class="text-danger text-sm"
                v-show="errors.has('casoDescripcion') || formerr.includes('casoDescripcion')">Por
                favor ingrese la
                descripci&oacute;n</span>
            </div>

            <!-- Proyecto -->
            <div>
              <label class="text-sm ">Proyecto</label>
              <v-select v-model="casoProyectoId" name="casoProyectoId" label="id" class="w-full mt-1 mb-3"
                :options="proyectoList" :reduce="item => item.id" :disabled="this.proyectoActive"
                :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoProyectoId') || formerr.includes('casoProyectoId')">Por
                favor seleccione el
                proyecto</span>
            </div>

            <!-- Subproyecto -->
            <div>
              <label class="text-sm ">Subproyecto</label>
              <v-select v-model="casoSubProyectoId" name="casoSubProyectoId" label="id" class="w-full mt-1 mb-3"
                :options="subProyectoList" :reduce="item => item.id" :disabled="this.subProyectoActive"
                @input="handleSubProyecto" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoSubProyectoId') || formerr.includes('casoSubProyectoId')">Por favor seleccione el subproyecto</span>
            </div>

            <!-- Fuente -->
            <div v-show="projectIdAddDataList.includes('61')">
              <label class="text-sm ">Fuente</label>
              <v-select v-model="casoFuenteId" name="casoFuenteId" label="id" class="w-full mt-1 mb-3"
                :options="sourceRequestList" :disabled="this.sourceRequestActive" :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoFuenteId') || formerr.includes('casoFuenteId')">Por favor seleccione la fuente</span>
            </div>

            <!-- Tipo actividad externa -->
            <div>
              <label class="text-sm ">Tipo actividad externa</label>
              <v-select v-model="casoTipoActividadExternaId" name="casoTipoActividadExternaId" label="id" class="w-full mt-1 mb-3"
                :options="tipoActividadExternaList" :reduce="item => item.id" :disabled="this.tipoActividadExternaActive" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoTipoActividadExternaId') || formerr.includes('casoTipoActividadExternaId')">Por
                favor seleccione el tipo actividad externa</span>
            </div>

            <!-- Prioridad -->
            <div v-show="projectIdAddDataList.includes('62')">
              <label class="text-sm ">Prioridad</label>
              <v-select v-model="casoPrioridadId" name="casoPrioridadId" label="id" class="w-full mt-1 mb-3"
                :options="prioridadList" :filter="fuseSearch">
                <template #selected-option="{ id }">
                  {{ id }}
                </template>
                <template #option="{ id }">
                  {{ id }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoPrioridadId') || formerr.includes('casoPrioridadId')">Por
                favor seleccione la prioridad</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-full md:w-1/2">
          <div>
            <!-- Tipo incidente -->
            <div>
              <label class="text-sm ">Tipo incidente</label>
              <v-select v-model="casoItilIncidentTypeId" name="casoItilIncidentTypeId" label="id"
                class="w-full mt-1 mb-3" :options="itilIncidentTypeList" :reduce="item => item.id"
                :disabled="this.itilIncidentTypeActive" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoItilIncidentTypeId') || formerr.includes('casoItilIncidentTypeId')">Por favor
                seleccione el tipo de incidente</span>
            </div>

            <!-- Criticidad -->
            <div v-show="projectIdAddDataList.includes('43')">
              <label class="text-sm ">Criticidad</label>
              <v-select v-model="casoCriticalityId" name="casoCriticalityId" label="id" class="w-full mt-1 mb-3"
                :options="criticalityList" :disabled="this.criticalityActive" :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoCriticalityId') || formerr.includes('casoCriticalityId')">Por
                favor seleccione la criticidad</span>
            </div>

            <!-- Servicio -->
            <div>
              <label class="text-sm ">Servicio</label>
              <v-select v-model="casoServicioId" name="casoServicioId" label="id" class="w-full mt-1 mb-3"
                :options="servicesList" :reduce="item => item.id" :disabled="this.servicesActive" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoServicioId') || formerr.includes('casoServicioId')">Por
                favor seleccione el servicio</span>
            </div>

            <!-- Grupo tipo de caso -->
            <div v-show="projectIdAddDataList.includes('59')">
              <label class="text-sm ">Grupo tipo de caso</label>
              <v-select v-model="casoGrupoTipoActividadId" name="casoGrupoTipoActividadId" label="id" class="w-full mt-1 mb-3"
                :options="grupo_tipo_actividadList" :disabled="this.grupo_tipo_actividadActive" @input="handleGrupoTipoCaso" :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoGrupoTipoActividadId') || formerr.includes('casoGrupoTipoActividadId')">Por favor seleccione el grupo tipo de caso</span>
            </div>

            <!-- Tipo de caso -->
            <label class="text-sm ">Tipo de caso</label>
            <v-select v-model="casoTipoActividadId" name="casoTipoActividadId" label="id" class="w-full mt-1 mb-3"
              :options="tipoActividadList" :reduce="item => item.id" :disabled="this.tipoActividadActive" @input="handleTipoCaso" :filter="fuseSearch">
              <template #selected-option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
              <template #option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
            </v-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoTipoActividadId') || formerr.includes('casoTipoActividadId')">Por favor seleccione el tipo de caso</span>

            <!-- Cuenta -->
            <div v-show="projectIdAddDataList.includes('70')" >
              <label class="text-sm ">Cuenta</label>
              <v-select v-model="casoCuentaId" name="casoCuentaId" label="id" class="w-full mt-1 mb-3"
                :options="cuentasList"  :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoCuentaId') || formerr.includes('casoCuentaId')">Por favor seleccione la cuenta</span>
            </div>

            <!-- Aplicaciones -->
            <div v-show="projectIdAddDataList.includes('60')">
              <label class="text-sm ">Aplicaciones</label>
              <v-select v-model="casoAplicativoId" name="casoAplicativoId" label="id" class="w-full mt-1 mb-3"
                :options="applicacionesList" :disabled="this.applicacionesActive" @input="handleApplicative" :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoAplicativoId') || formerr.includes('casoAplicativoId')">Por favor seleccione la
                aplicación</span>
            </div>

            <!-- Infraestructura -->
            <div v-show="projectIdAddDataList.includes('52')">
              <label class="text-sm ">Infraestructura</label>
              <v-select v-model="casoHelpDesk" name="casoHelpDesk" label="id" class="w-full mt-1 mb-3"
                :options="infraestructuraList" :disabled="this.infraestructuraActive" @input="handleHelpDesk" :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoHelpDesk') || formerr.includes('casoHelpDesk')">Por favor seleccione la infraestructura</span>
            </div>

            <!-- Usuario que atiende -->
            <div v-show="projectIdAddDataList.includes('63')">
              <label class="text-sm ">Usuario que atiende</label>
              <v-select v-model="casoUsuarioAtiendeId" name="casoUsuarioAtiendeId" label="id" class="w-full mt-3 mb-3"
                :disabled="this.resourceByProjectActive" :options="resourceByProjectList" :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoUsuarioAtiendeId') || formerr.includes('casoUsuarioAtiendeId')">Por favor seleccione el usuario que atiende</span>
            </div>

            <!-- Usuario que registra -->
            <div v-show="projectIdAddDataList.includes('72')">
              <label class="text-sm ">Usuario que registra</label>
              <v-select v-model="casoUsuarioRegistraId" name="casoUsuarioRegistraId" label="id" class="w-full mt-3 mb-3"
                :disabled="this.resourceByProjectActive" :options="resourceByProjectList" :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoUsuarioRegistraId') || formerr.includes('casoUsuarioRegistraId')">Por favor seleccione el usuario que registra</span>
            </div>

            <!-- Clase de caso -->
            <div v-show="projectIdAddDataList.includes('64')">
              <label class="text-sm ">Clase de caso</label>
              <v-select v-model="casoClaseCasoId" name="casoClaseCasoId" label="id" class="w-full mt-1 mb-3"
                :options="requestClassList" :disabled="this.requestClassActive" :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm"
                v-show="errors.has('casoClaseCasoId') || formerr.includes('casoClaseCasoId')">Por
                favor seleccione la clase de caso</span>
            </div>

            <!-- Área -->
            <div v-show="projectIdAddDataList.includes('65')">
              <label class="text-sm ">Área</label>
              <v-select v-model="casoAreaId" name="casoAreaId" label="id" class="w-full mt-1 mb-3"
                :options="areaByResourceList" :disabled="this.areaByResourceActive" :reduce="item => item.id" :filter="fuseSearch">
                <template #selected-option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
                <template #option="{ id, descripcion }">
                  {{ id }} - {{ descripcion }}
                </template>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('casoAreaId') || formerr.includes('casoAreaId')">Por favor seleccione el área</span>
            </div>

            <!-- Fecha de compromiso -->
            <div class="w-full mt-4" v-show="projectIdAddDataList.includes('66')">
              <label for="casoFechaCompromiso" class="vs-input--label">Fecha de compromiso</label>
              <flat-pickr class="vs-inputx vs-input--input normal" id="casoFechaCompromiso" :config="configdateIni"
                :disabled="true" v-model="casoFechaCompromiso" placeholder="dd/mm/aaaa" @on-change="onFromChange" />
              <span class="text-danger text-sm"
                v-show="errors.has('casoFechaCompromiso') || formerr.includes('casoFechaCompromiso')">Por favor seleccione la fecha de compromiso</span>
            </div>
          </div>
        </div>
        <div class="vx-col w-full">
          <div>
            <!-- Adjuntar archivos -->
            <div class="w-full mt-4">
              <label for="files" class="vs-input--label">Adjuntar archivos</label>
              <file-pond name="test" ref="pond" label-idle="Suelta los archivos aquí..." class="w-full"
                allow-multiple="true" accepted-file-types="image/jpeg, image/png" v-on:addfile="handleFilePondAddFile"
                v-on:removefile="handleFilePondRemoveFile" v-on:init="handleFilePondInit" />
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card class="mt-6 mb-6" v-if="casoTipoActividadId">
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-center px-3">
              <feather-icon svgClasses="w-6 h-6" icon="ListIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Detalles</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <vs-tabs>
          <vs-tab label="Datos adicionales">
            <div class="block overflow-x-auto">
              <vs-table :data="additionalDataListTmp">
                <template slot="thead">
                  <vs-th v-for="addData in additionalDataListTmp" :key="'header_' + addData.id_req_type_by_add_data">
                    {{ addData.display_name }}
                  </vs-th>
                </template>

                <template>
                  <vs-tr>
                    <vs-td v-for="addData in additionalDataListTmp" :key="'input_' + addData.id_req_type_by_add_data">
                      <vs-input
                        class="inputx"
                        :value="addData.value"
                        @input="(event) => updateAdditionalData(addData.id_req_type_by_add_data, event)"
                        :type="addData.data_type === 'VARCHAR' ? 'text' :
                              addData.data_type === 'NUMBER' ? 'number' :
                              addData.data_type === 'LINK' ? 'url' : 'text'"
                      />
                      <span class="text-danger text-sm"
                        v-show=" formerr.includes('addData_'+addData.id_req_type_by_add_data)">
                        Obligatorio
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>
          <!-- <vs-tab label="Observaciones">
            <div class="block overflow-x-auto">
              <observacion-caso-list-view :casoProp="casoData" v-if="casoData !== undefined">
              </observacion-caso-list-view>
            </div>
          </vs-tab>
          <vs-tab label="Archivos adjuntos">
            <div class="block overflow-x-auto">
              <archivo-adjunto-caso-list-view :casoProp="casoData" v-if="casoData !== undefined">
              </archivo-adjunto-caso-list-view>
            </div>
          </vs-tab> -->
          <!-- <vs-tab label="Proponentes">
            <div class="block overflow-x-auto">
              <proponente-list-view
                :casoProp="casoData"
                v-if="casoData !== undefined"
              ></proponente-list-view>
            </div>
          </vs-tab> -->
        </vs-tabs>
      </vx-card>

    <div class="vx-col w-full flex" id="account-manage-buttons">
      <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="actionSaveData">Guardar</vs-button>
      <vs-button type="border" color="danger" icon-pack="feather" @click="closeSidebar">Cancelar</vs-button>
    </div>
  </div>
</template>

<script>
//Fuse
import Fuse from 'fuse.js'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Create component
const FilePond = vueFilePond()
//////////////////////////////////////////////////////////////////////////////////////////////////////////////
import ListasModule from '@/store/listas-module/moduleDataList.js'
import DatoAdicionalModule from '@/store/dato-adicional-module/moduleDataList.js'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish as SpanishLocale } from 'flatpickr/dist/l10n/es.js'
import { companiesEnums, searchCompany, searchCompanyById } from '../../../config/companies.js'
import validateConfigData from '../../../helpers/validateConfigData'
import { onBeforeUnmount } from 'vue'

export default {
  components: {
    Datepicker,
    flatPickr,
    FilePond
  },
  props: {
    modeCreateProp: {
      type: Boolean,
      default: true
    },
    casoDataProp: {
      type: Object,
      default: () => { }
    },
    createNewCasoProp: {
      type: Function
    },
    editCasoProp: {
      type: Function
    },
    closeSidebarProp: {
      type: Function
    }
  },
  data() {
    return {
      titleCard: '', // Crear/Modificar Caso
      modeCreate: true, // Crear => true/Modificar => false
      formerr: [], // Crear => true/Modificar => false
      company: null,
      casoId: null,
      casoAsunto: '',
      casoDescripcion: '',
      casoCompaniaId: '',
      casoProyectoId: '',
      casoSubProyectoId: '',
      casoCuentaId: {id: -1, descripcion: 'N/A'},
      casoArea: this.$store.state.auth.userDetails().department || 'Área Genérica',
      casoAreaId: this.$store.state.auth.userDetails().department ? 1 : 68,
      casoServicioId: null,
      casoCodigoExterno: null,
      casoPrioridadId: null,
      casoCriticalityId: null,
      casoItilIncidentType: null,
      casoItilIncidentTypeId: null,
      casoFuenteId: null,
      casoTipoActividadExternaId: '',
      casoGrupoTipoActividadId: null,
      casoTipoActividadId: null,
      casoAplicativoId: null,
      casoHelpDesk: null,
      casoUsuarioAtiendeId: null,
      casoUsuarioRegistraId: null,
      casoClaseCasoId: null,
      prioridadList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      myFiles: [],
      user_data: {},
      user_not_found: false,
      dob: new Date(),
      fechaini: null,
      casoFechaCompromiso: new Date(),
      configdateIni: {
        enableTime: true,
        //dateFormat: 'd-m-Y H:i', // dd/mm/aaaa H:m:s
        dateFormat: 'd/m/Y',
        locale: SpanishLocale,
        maxDate: null,
        // enableSeconds: true,
        minDate: new Date()
      },
      validateConfigData,
      tipoActividadListTmp: [],
      subProyectoListTmp: [],
      tipoActividadExternaListTmp: [],
      sourceRequestListTmp: [],
      criticalityListTmp: [],
      requestClassListTmp: [],
      areaByResourceListTmp: [],
      additionalDataListTmp: [],
      resourceByProjectListTmp: [],
      helpDeskServiceListTmp: [],
      applicativeListTmp: [],
      isInitializing: false
    }
  },
  updated() {
    console.log('formerr', JSON.stringify(this.formerr))
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.formerr.length <= 0
    },
    companiasList() {
      return this.$store.state.ListasModule.companies
    },
    proyectoList() {
      return this.$store.state.ListasModule.proyecto
    },
    subProyectoList() {
      return this.$store.state.ListasModule.sub_proyecto
    },
    itilIncidentTypeList() {
      return this.$store.state.ListasModule.itil_incident_type
    },
    sourceRequestList() {
      return this.$store.state.ListasModule.source_request
    },
    tipoActividadExternaList() {
      return this.$store.state.ListasModule.tipo_actividad_externa
    },
    criticalityList() {
      return this.$store.state.ListasModule.criticality
    },
    servicesList() {
      return this.$store.state.ListasModule.servicios
    },
    applicacionesList() {
      return this.$store.state.ListasModule.applicative
    },
    infraestructuraList() {
      return this.$store.state.ListasModule.help_desk
    },
    grupo_tipo_actividadList() {
      return this.$store.state.ListasModule.grupo_tipo_actividad
    },
    tipoActividadList() {
      return this.$store.state.ListasModule.tipo_actividad
    },
    projectAddData() {
      return this.$store.state.ListasModule.project_add_data
    },
    requestClassList() {
      return this.$store.state.ListasModule.request_class
    },
    areaByResourceList() {
      return this.$store.state.ListasModule.area_by_resource
    },
    projectIdAddDataList() {
      return this.$store.state.ListasModule.projectId_add_data
    },
    companiasActive() {
      return this.$store.state.ListasModule.companies.length === 0
    },
    proyectoActive() {
      return this.$store.state.ListasModule.proyecto.length === 0
    },
    subProyectoActive() {
      return this.$store.state.ListasModule.sub_proyecto.length === 0
    },
    itilIncidentTypeActive() {
      return this.$store.state.ListasModule.itil_incident_type.length === 0
    },
    sourceRequestActive() {
      return this.$store.state.ListasModule.source_request.length === 0
    },
    tipoActividadExternaActive() {
      return this.$store.state.ListasModule.tipo_actividad_externa.length === 0
    },
    criticalityActive() {
      return this.$store.state.ListasModule.criticality.length === 0
    },
    servicesActive() {
      return this.$store.state.ListasModule.servicios.length === 0
    },
    grupo_tipo_actividadActive() {
      return this.$store.state.ListasModule.grupo_tipo_actividad.length === 0
    },
    tipoActividadActive() {
      return this.$store.state.ListasModule.tipo_actividad.length === 0
    },
    applicacionesActive() {
      return this.$store.state.ListasModule.applicative.length === 0
    },
    infraestructuraActive() {
      return this.$store.state.ListasModule.help_desk.length === 0
    },
    requestClassActive() {
      return this.$store.state.ListasModule.request_class.length === 0
    },
    areaByResourceActive() {
      return this.$store.state.ListasModule.area_by_resource.length === 0
    },
    cuentasList() {
      return this.$store.state.ListasModule.accounts
    },
    resourceByProjectList() {
      return this.$store.state.ListasModule.resource_by_project
    },
    resourceByProjectActive() {
      return this.$store.state.ListasModule.resource_by_project.length === 0
    }
  },
  async created() {

    this.clearAllList()
    this.company = searchCompany(this.$route.params.nameCompany)

    this.modeCreate = this.modeCreateProp
    console.log('modeCreate', this.modeCreate)

    if (this.modeCreate) { this.casoCompaniaId = this.company.idCompany }
    if (!this.modeCreate) { this.isInitializing = true }

    await this.initListOfValues()

    if (this.isInitializing) {
      this.$nextTick(() => {
        if (!this.modeCreate && this.casoProyectoId) {
          //this.handleProyecto(this.casoProyectoId)
        }
        this.isInitializing = false
      })
    }
  },
  watch: {
    casoDataProp() {
      this.initParams()
    },
    casoCompaniaId(newVal) {
      //console.log("ID de la compañía seleccionada:", newVal);
      // Si necesitas obtener la descripción
      const companiaSeleccionada = this.companiasList.find(c => c.id === newVal);
      if (companiaSeleccionada) {
        //console.log("Compañía seleccionada:", companiaSeleccionada);
      }
    },
    casoProyectoId(newVal) {
      if (newVal && !this.isInitializing) {
        this.handleProyecto(newVal)
      }
    },
    casoServicioId(newVal) {
      if (newVal) {
        this.handleServicio(newVal)
      }
    }

  },
  methods: {
    fuseSearch(options, search) {
      //console.log("Opciones disponibles:", options);
      //console.log("Término de búsqueda:", search);

      if (!search) return options;

      const fuse = new Fuse(options, {
        keys: ['id', 'descripcion'],
        threshold: 0.3,
        shouldSort: true,
      });

      const results = fuse.search(search).map(result => result.item);
      //console.log("Resultados filtrados:", results);

      return results;
    },
    async initListOfValues() {
      if (!ListasModule.isRegistered) {
        this.$store.registerModule('ListasModule', ListasModule)
        ListasModule.isRegistered = true
      }
      if (!DatoAdicionalModule.isRegistered) {
        this.$store.registerModule('DatoAdicionalModule', DatoAdicionalModule)
        DatoAdicionalModule.isRegistered = true
      }

      //this.casoCompaniaId = searchCompany(this.$route.params.nameCompany).idCompany

      await this.initParams()

      await this.getAllCompanias()

      await this.getAllProyecto()

    },
    async initParams(force = false) {
      if (
        force ||
        this.casoDataProp === null ||
        this.casoDataProp.id === null ||
        this.casoDataProp.id === undefined ||
        this.casoDataProp.id === ''
      ) {
        this.modeCreate = true
        this.titleCard = 'Crear caso'
        this.casoId = null
        this.casoAsunto = ''
        this.casoDescripcion = ''
        this.casoServicioId = null
        this.casoTipoActividadId = null
        this.fechaini = null
        this.casoCodigoExterno = null
        this.casoTipoActividadExternaId = null
        this.casoPrioridadId = null
        this.casoCriticalityId = null
        this.casoItilIncidentType = null
        this.casoProyectoId = null
        this.casoCuentaId = {id: -1, descripcion: 'N/A'}
        this.casoUsuarioRegistraId = this.$store.state.auth.userDetails().id
      } else {
        //console.log('Modificando, this.casoDataProp', this.casoDataProp)
        this.modeCreate = false
        this.titleCard = 'Modificar caso'
        this.casoId = this.casoDataProp.id
        this.casoCompaniaId = this.casoDataProp.compañia ? this.casoDataProp.compañia.id : this.company.idCompany
        this.casoAsunto = this.casoDataProp.asunto
        this.casoDescripcion = this.casoDataProp.descripcion
        this.casoServicioId = this.casoDataProp.requestTypeService && this.casoDataProp.requestTypeService.id !== 0 ? this.casoDataProp.requestTypeService.id : null
        this.casoTipoActividadId = this.casoDataProp.tipoActividad && this.casoDataProp.tipoActividad !== 0 ? this.casoDataProp.tipoActividad.id : null
        this.casoGrupoTipoActividadId = this.casoDataProp.groupTipCaso && this.casoDataProp.groupTipCaso.id !== 0 ? this.casoDataProp.groupTipCaso.id : null
        this.fechaini = this.casoDataProp.fechaAcordada
        this.casoCodigoExterno = this.casoDataProp.USU_RESPO_NOMBRE
        this.casoTipoActividadExternaId = this.casoDataProp.tipoActividadExterna && this.casoDataProp.tipoActividadExterna.id !== 0 ? this.casoDataProp.tipoActividadExterna.id : null
        this.casoPrioridadId = this.casoDataProp.prioridad
        this.casoCriticalityId = this.casoDataProp.criticality && this.casoDataProp.criticality.id !== 0 ? this.casoDataProp.criticality.id : null
        this.casoItilIncidentTypeId = this.casoDataProp.itilIncidentType && this.casoDataProp.itilIncidentType.id !== 0 ? this.casoDataProp.itilIncidentType.id : null
        this.casoProyectoId = this.casoDataProp.proyecto && this.casoDataProp.proyecto.id !== 0 ? this.casoDataProp.proyecto.id : null
        this.casoSubProyectoId = this.casoDataProp.subproyecto && this.casoDataProp.subproyecto.id !== 0 ? this.casoDataProp.subproyecto.id : null
        this.casoCuentaId = this.casoDataProp.casoCuentaId ? this.casoDataProp.casoCuentaId : {id: -1, descripcion: 'N/A'}
        this.casoUsuarioAtiendeId = this.casoDataProp.usuario ? this.casoDataProp.usuario : null
        this.casoUsuarioRegistraId = this.casoDataProp.usuario || this.$store.state.auth.userDetails().id
        this.casoHelpDesk = this.casoDataProp.helpDeskService && this.casoDataProp.helpDeskService.id !== 0 ? this.casoDataProp.helpDeskService.id : null
      }

      this.$validator.reset()
    },
    actionSaveData() {
      //console.log('this.myFiles', this.myFiles)
      //console.log('user', this.$store.state.auth.userDetails())
      //console.log('nameCompany', this.$route.params.nameCompany)

      if (!this.company) {
        alert('El nombre de la compañia no es correcto.')

        return
      }

      /*this.myFiles.forEach(element => {
        console.log('file', element.name)
      })*/
      this.formerr = []
      if (
        this.casoId === null ||
        this.casoId === undefined
      ) {
        //TODO, revisar la validación
        //this.formerr.push('casoId')
      }
      if (
        this.casoCompaniaId === null ||
        this.casoCompaniaId === undefined ||
        this.casoCompaniaId === ''
      ) {
        this.formerr.push('casoCompaniaId')
      }
      if (this.projectIdAddDataList.includes('67')) {
        if (
          this.casoAsunto === null ||
          this.casoAsunto === undefined ||
          this.casoAsunto.trim() === ''
        ) {
          this.formerr.push('casoAsunto')
        }
      }
      if (
        this.casoDescripcion === null ||
        this.casoDescripcion === undefined ||
        this.casoDescripcion.trim() === ''
      ) {
        this.formerr.push('casoDescripcion')
      }
      if (
        this.casoProyectoId === null ||
        this.casoProyectoId === undefined ||
        this.casoProyectoId === ''
      ) {
        this.formerr.push('casoProyectoId')
      }
      if (
        (this.casoSubProyectoId === null ||
        this.casoSubProyectoId === undefined ||
        this.casoSubProyectoId === '') &&
        !this.subProyectoActive
      ) {
        this.formerr.push('casoSubProyectoId')
      }
      if (
        this.casoItilIncidentTypeId === null ||
        this.casoItilIncidentTypeId === undefined ||
        this.casoItilIncidentTypeId === ''
      ) {
        this.formerr.push('casoItilIncidentTypeId')
      }
      if (this.projectIdAddDataList.includes('61')) {
        if (
          this.casoFuenteId === null ||
          this.casoFuenteId === undefined ||
          this.casoFuenteId === ''
        ) {
          this.formerr.push('casoFuenteId')
        }
      }
      if (
        this.casoTipoActividadExternaId === null ||
        this.casoTipoActividadExternaId === undefined ||
        this.casoTipoActividadExternaId === ''
      ) {
        this.formerr.push('casoTipoActividadExternaId')
      }
      if (this.projectIdAddDataList.includes('62')) {
        if (
          this.casoPrioridadId === null ||
          this.casoPrioridadId === undefined ||
          this.casoPrioridadId === ''
        ) {
          this.formerr.push('casoPrioridadId')
        }
      }
      if (this.projectIdAddDataList.includes('43')) {
        if (
          this.casoCriticalityId === null ||
          this.casoCriticalityId === undefined ||
          this.casoCriticalityId === ''
        ) {
          this.formerr.push('casoCriticalityId')
        }
      }
      if (
        this.casoServicioId === null ||
        this.casoServicioId === undefined ||
        this.casoServicioId === ''
      ) {
        this.formerr.push('casoServicioId')
      }
      if (this.projectIdAddDataList.includes('59')) { //if (!this.grupo_tipo_actividadActive) {
        if (
          this.casoGrupoTipoActividadId === null ||
          this.casoGrupoTipoActividadId === undefined ||
          this.casoGrupoTipoActividadId === ''
        ) {
          this.formerr.push('casoGrupoTipoActividadId')
        }
      }
      if (
        this.casoTipoActividadId === null ||
        this.casoTipoActividadId === undefined ||
        this.casoTipoActividadId === ''
      ) {
        this.formerr.push('casoTipoActividadId')
      }
      if (this.projectIdAddDataList.includes('52')) {
        if (this.casoAplicativoId === null) {
          if (
            this.casoHelpDesk === null ||
            this.casoHelpDesk === undefined ||
            this.casoHelpDesk === ''
          ) {
            this.formerr.push('casoHelpDesk')
          }
        }
      }
      if (this.projectIdAddDataList.includes('70')) {
        if (
          this.casoCuentaId === null ||
          this.casoCuentaId === undefined ||
          this.casoCuentaId === ''
        ) {
          this.formerr.push('casoCuentaId')
        }
      }
      if (this.projectIdAddDataList.includes('60')) {
        if (this.casoHelpDesk === null) {
          if (
            this.casoAplicativoId === null ||
            this.casoAplicativoId === undefined ||
            this.casoAplicativoId === ''
          ) {
            this.formerr.push('casoAplicativoId')
          }
        }
      }
      if (this.projectIdAddDataList.includes('64')) {
        if (
          this.casoClaseCasoId === null ||
          this.casoClaseCasoId === undefined ||
          this.casoClaseCasoId === ''
        ) {
          this.formerr.push('casoClaseCasoId')
        }
      }
      if (this.projectIdAddDataList.includes('65')) {
        if (
          this.casoAreaId === null ||
          this.casoAreaId === undefined ||
          this.casoAreaId === ''
        ) {
          this.formerr.push('casoAreaId')
        }
      }
      if (this.projectIdAddDataList.includes('63')) {
        if (
          (this.casoUsuarioAtiendeId === null ||
          this.casoUsuarioAtiendeId === undefined ||
          this.casoUsuarioAtiendeId === '') &&
          !this.resourceByProjectActive
        ) {
          this.formerr.push('casoUsuarioAtiendeId')
        }
      }
      if (this.projectIdAddDataList.includes('72')) {
        if (
          (this.casoUsuarioRegistraId === null ||
          this.casoUsuarioRegistraId === undefined ||
          this.casoUsuarioRegistraId === '') &&
          !this.resourceByProjectActive
        ) {
          this.formerr.push('casoUsuarioRegistraId')
        }
      }

      //console.log("this.additionalDataListTmp, ", this.additionalDataListTmp)

      if (validateConfigData('73') && validateConfigData('73') === 'Y') {
        this.additionalDataListTmp.forEach(addData => {
          if (
            addData.is_required === "Y" &&
            addData.value === null ||
            addData.value === undefined ||
            addData.value === ''
          ) {
            this.formerr.push('addData_'+addData.id_req_type_by_add_data)
          }
        })
      }

      if (this.validateForm) {

        //console.log('this.casoAplicativoId', this.casoAplicativoId)
        //console.log('this.casoHelpDesk', this.casoHelpDesk)
        //console.log('this.casoClaseCasoId', this.casoClaseCasoId)

        let additionalData = []

        this.additionalDataListTmp.forEach(addData => {
          additionalData.push({
            value: addData.value,
            id_req_type_by_add_data: addData.id_req_type_by_add_data,
          })
        })

        //console.log("this.additionalDataListTmp: ", this.additionalDataListTmp)
        //console.log("additionalData", additionalData)

        const casoDataProp = {
          id: this.casoId ? this.casoId : -1,
          company: { id: this.casoCompaniaId, descripcion: '' },
          subject_req: this.casoAsunto,
          descripcion: this.casoDescripcion,
          proyecto: this.casoProyectoId ? { id: this.casoProyectoId, idCompania: this.casoCompaniaId, descripcion: '' } : null,
          subproyecto: this.casoSubProyectoId ? this.casoSubProyectoId.id ? this.casoSubProyectoId : { id: this.casoSubProyectoId, idCompania: null, descripcion: '' } : null,
          itilIncidentType: this.casoItilIncidentTypeId ? { id: this.casoItilIncidentTypeId, descripcion: '' } : null,
          source: this.casoFuenteId ? this.casoFuenteId.id ? this.casoFuenteId : { id: this.casoFuenteId, descripcion: '' } : null,
          tipoActividadExterna: this.casoTipoActividadExternaId ? this.casoTipoActividadExternaId.id ? this.casoTipoActividadExternaId : { id: this.casoTipoActividadExternaId, idCompania: this.casoCompaniaId, descripcion: '' } : null,
          prioridad: this.casoPrioridadId,
          criticality: this.casoCriticalityId ? this.casoCriticalityId.id ? this.casoCriticalityId : { id: this.casoCriticalityId, descripcion: '' } : null,
          requestTypeService: this.casoServicioId ? { id: this.casoServicioId, descripcion: '' } : null,
          groupTipCaso: this.casoGrupoTipoActividadId ? { id: this.casoGrupoTipoActividadId, descripcion: '' } : null,
          tipoActividad: this.casoTipoActividadId ? this.casoTipoActividadId.id ? this.casoTipoActividadId : { id: this.casoTipoActividadId, idCompania: this.company.idCompany, descripcion: '' } : null,
          app: this.casoAplicativoId ? { id: this.casoAplicativoId, descripcion: '' } : null,
          helpDeskService: this.casoHelpDesk ? { id: this.casoHelpDesk, descripcion: '' } : null,
          requestClass: this.casoClaseCasoId ? this.casoClaseCasoId.id ? this.casoClaseCasoId : { id: this.casoClaseCasoId, descripcion: '' } : null, // Clase de caso
          area: this.casoAreaId ? this.casoAreaId.id ? this.casoAreaId : { id: this.casoAreaId, descripcion: '' } : null,
          usuario: this.casoUsuarioRegistraId || this.$store.state.auth.userDetails().id,
          //usuarioAsignado: { id: this.$store.state.auth.userDetails().id, name: this.$store.state.auth.userDetails().name },
          usuarioAsignado: this.casoUsuarioAtiendeId ? this.casoUsuarioAtiendeId.id ? this.casoUsuarioAtiendeId : { id: this.casoUsuarioAtiendeId || this.$store.state.auth.userDetails().id, name: '' } : { id: this.$store.state.auth.userDetails().id, name: '' },
          fechaAcordada: this.casoFechaCompromiso,
          codigoInterno: -1,
          myFiles: this.myFiles,
          gesActivo: null,
          cuenta: this.casoCuentaId ? this.casoCuentaId.id ? this.casoCuentaId : { id: this.casoCuentaId, descripcion: '' } : null,
          additionalData: additionalData
        }

        //console.log('this.casoUsuarioRegistraId', this.casoUsuarioRegistraId)
        //console.log('New Request', casoDataProp)

        if (this.modeCreate) {
          this.createNewCasoProp(casoDataProp)
        } else {
          this.editCasoProp(casoDataProp)
        }
      } else {
        console.log('Hay errores que resolver', this.errors)
      }
    },
    async handleCompania(item) {
      this.company = searchCompanyById(item)
      await this.getAllProyecto()
    },
    async getAllCompanias() {
      this.$vs.loading()
      await this.$store
        .dispatch('ListasModule/getCompanias', { ...this.company, idUser: this.$store.state.auth.userDetails().id })
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    async getAllProyecto() {

      // Eliminamos la lista de datos de los proyectos
      if (!this.isInitializing) this.casoProyectoId = null
      this.$store.dispatch('ListasModule/clearAllProyecto')

      // Eliminamos la lista de todos los demás datos
      if (!this.isInitializing) this.clearAllList()

      const item = this.modeCreate && !this.casoCompaniaId ?
        {...this.company} :
        {idCompany: this.casoCompaniaId}
      item.idUser = this.$store.state.auth.userDetails().id

      this.$vs.loading()
      await this.$store
        .dispatch('ListasModule/getAllProyecto', item)
        .then(async (response) => {
          this.$vs.loading.close()

          if (response.data) {
            const list = response.data.listaProyecto
            if (list) {
              if (list.length === 1) {
                const id = list[0].id
                this.casoProyectoId = id

                await this.handleProyecto(id)
              }
            }
          }
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    clearAllList() {

      this.casoSubProyectoId = ''
      this.casoItilIncidentTypeId = null
      this.casoFuenteId = null
      this.casoTipoActividadExternaId = null
      this.casoPrioridadId = null
      this.casoCriticalityId = null
      this.casoServicioId = null
      this.casoGrupoTipoActividadId = null
      this.casoTipoActividadId = null
      this.casoAplicativoId = null
      this.casoHelpDesk = null
      this.casoUsuarioAtiendeId = null
      this.casoUsuarioRegistraId = null
      this.casoClaseCasoId = null
      this.casoAreaId = null
      this.casoCuentaId = {id: -1, descripcion: 'N/A'}

      this.$store.dispatch('ListasModule/clearAllSubProyecto')
      this.$store.dispatch('ListasModule/clearAllItilIncidentType')
      this.$store.dispatch('ListasModule/clearAllSourceRequest')
      this.$store.dispatch('ListasModule/clearAllTipoActividadExterna')
      this.$store.dispatch('ListasModule/clearAllCriticality')
      this.$store.dispatch('ListasModule/clearAllServicios')
      this.$store.dispatch('ListasModule/clearAllGrupoTipoActividad')
      this.$store.dispatch('ListasModule/clearAllTipoActividad')
      this.$store.dispatch('ListasModule/clearAllApplicative')
      this.$store.dispatch('ListasModule/clearAllHelpDesk')
      this.$store.dispatch('ListasModule/clearAllRequestClass')
      this.$store.dispatch('ListasModule/clearAllAreaByResource')
      this.$store.dispatch('ListasModule/clearAllProjectAddData')
      this.$store.dispatch('ListasModule/clearAllProjectIdAddData')
      this.$store.dispatch('ListasModule/clearAccountByFilter')
      this.$store.dispatch('ListasModule/clearResourceByProject')
    },
    async handleProyecto(item) {

      if (!this.isInitializing) this.clearAllList()

      if (item) {
        const companyTemp = {
          idCompany: this.casoCompaniaId,
          idProject: item
        }
        //console.log('companyTemp', companyTemp)

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllSubProyecto', companyTemp)
          .then((response) => {
            if (response && response.data) {
              this.subProyectoListTmp = response.data.listaSubproyecto
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllItilIncidentType', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getSourceRequest', companyTemp)
          .then((response) => {
            if (response) {
              this.sourceRequestListTmp = response.listaSourceRequest
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllTipoActividadExterna', companyTemp)
          .then((response) => {
            if (response && response.data) {
              this.tipoActividadExternaListTmp = response.data.listaTipoActividadExterna
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllCriticality', companyTemp)
          .then((response) => {
            if (response && response.data) {
              this.criticalityListTmp = response.data.listaCriticality
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllServicios', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllApplicative', companyTemp)
          .then((response) => {
            if (response) {
              this.applicativeListTmp = response.data.listaApp
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllHelpDesk', companyTemp)
          .then((response) => {
            if (response) {
              this.helpDeskServiceListTmp = response.data.listaHelpDeskService
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getRequestClass', companyTemp)
          .then((response) => {
            if (response) {
              this.requestClassListTmp = response.listaRequestClass
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllGrupoTipoActividad', { ...companyTemp, idUser: this.$store.state.auth.userDetails().id })
          .then((response) => {
            this.$vs.loading.close()

            if (response.data) {
              if (response.data.listaGroupTipCaso.length === 0) {
                this.handleGrupoTipoCaso(-1)
              }
            }
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAreaByResource', { ...companyTemp, idUser: this.$store.state.auth.userDetails().id })
          .then((response) => {

            //this.casoAreaId = this.area_by_resourceList && this.area_by_resourceList.length === 1 ? this.area_by_resourceList[0].id : null
            //this.casoArea = this.area_by_resourceList && this.area_by_resourceList.length === 1 ? this.area_by_resourceList[0] : null

            if (response.data) {
              if (!response.data.listaArea) {
                this.$store.dispatch('ListasModule/setAreaByResource', { lista: [{ id: 1, descripcion: this.$store.state.auth.userDetails().department }] })
              } else {
                this.areaByResourceListTmp = response.data.listaArea
              }
            }

            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$store
          .dispatch('ListasModule/getResourceByProject',
            {
              ...this.company,
              idUser: this.$store.state.auth.userDetails().id,
              idProject: item
            })
          .then((response) => {
            if (response.data) {
              this.resourceByProjectListTmp = response.data.listaResource
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        // Configuración por proyecto
        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getProjectAddData', companyTemp)
          .then((response) => {

            //console.log('getProjectAddData response, ', response)
            if (this.modeCreate) {
              this.casoFuenteId = validateConfigData('68')
              this.casoPrioridadId = validateConfigData('69')
              this.casoCriticalityId = validateConfigData('54')
              this.casoTipoActividadId = validateConfigData('48')
              this.casoAreaId = validateConfigData('50')
              this.casoUsuarioAtiendeId = validateConfigData('49')
              this.casoUsuarioRegistra = validateConfigData('72')
              this.casoTipoActividadExternaId = validateConfigData('56')
              this.casoSubProyectoId = validateConfigData('57')
              this.casoClaseCasoId = validateConfigData('58')
              this.casoHelpDesk = validateConfigData('74')
              this.casoAplicativoId = validateConfigData('75')

              if (this.casoFuenteId) {
                this.casoFuenteId = this.sourceRequestListTmp.find(c => String(c.id) === String(this.casoFuenteId))
              }
              if (this.casoCriticalityId) {
                this.casoCriticalityId = this.criticalityListTmp.find(c => String(c.id) === String(this.casoCriticalityId))
              }
              if (this.casoTipoActividadId && this.modeCreate) {
                this.casoTipoActividadId = this.tipoActividadListTmp.find(c => String(c.id) === String(this.casoTipoActividadId))
              }
              if (this.casoTipoActividadExternaId) {
                this.casoTipoActividadExternaId = this.tipoActividadExternaListTmp.find(c => String(c.id) === String(this.casoTipoActividadExternaId))
              }
              if (this.casoSubProyectoId) {
                this.casoSubProyectoId = this.subProyectoListTmp.find(c => String(c.id) === String(this.casoSubProyectoId))
              }
              if (this.casoClaseCasoId) {
                this.casoClaseCasoId = this.requestClassListTmp.find(c => String(c.id) === String(this.casoClaseCasoId))
              }
              if (this.casoAreaId) {
                this.casoAreaId = this.areaByResourceListTmp.find(c => String(c.id) === String(this.casoAreaId))
              }
              if (this.casoUsuarioAtiendeId) {
                this.casoUsuarioAtiendeId = this.resourceByProjectListTmp.find(c => String(c.id) === String(this.casoUsuarioAtiendeId))
              }
              if (this.casoUsuarioRegistra) {
                this.casoUsuarioRegistraId = this.$store.state.auth.userDetails().id
              }
              if (this.casoHelpDesk) {
                this.casoHelpDesk = this.helpDeskServiceListTmp(c => String(c.id) === String(this.casoHelpDesk))
              }
              if (this.casoAplicativoId) {
                this.casoAplicativoId = this.applicativeListTmp(c => String(c.id) === String(this.casoAplicativoId))
              }
            }

            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        const dataTmp = {
          idCompany: this.company.idCompany,
          idProject: -1,
          idSubProject: -1
        }

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAccountByFilter', dataTmp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
    },
    handleSubProyecto(item) {

      if (this.company.nameCompany === companiesEnums.MESOFOODS) {
        const dataTmp = {
          idCompany: this.company.idCompany,
          idProject: this.casoProyectoId,
          idSubProject: item
        }

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAccountByFilter', dataTmp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
    },
    handleServicio(item) {
      if (!this.isInitializing) this.casoTipoActividadId = null // TODO

      this.tipoActividadListTmp = []
      this.$store.dispatch('ListasModule/clearAllTipoActividad')

      this.$vs.loading()

      this.$store
        .dispatch('ListasModule/getAllTipoActividad', { idCompany: this.casoCompaniaId, idProject: this.casoProyectoId, idRequestTypeService: item, idGrupoRequestType: this.casoGrupoTipoActividadId || -1 })
        .then((response) => {
          if (response && response.data) {
            this.tipoActividadListTmp = response.data.listaTipoActividad
          }
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    handleGrupoTipoCaso(item) {
      if (item !== -1) this.casoTipoActividadId = null
      this.tipoActividadListTmp = []
      this.$store
        .dispatch('ListasModule/setAllTipoActividad', { lista: [] })

      if (item !== null) {
        this.$vs.loading()
        this.$store
        .dispatch('ListasModule/getAllTipoActividad', { idCompany: this.casoCompaniaId, idProject: this.casoProyectoId, idRequestTypeService: this.casoServicioId, idGrupoRequestType: item })
          .then((response) => {
            if (response && response.data) {
              this.tipoActividadListTmp = response.data.listaTipoActividad
            }
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
    },
    handleTipoCaso(item) {
      this.$store
        .dispatch('DatoAdicionalModule/setAddDataListState', { lista: [] })

      if (item) {
        this.$vs.loading()
        this.$store
        .dispatch('DatoAdicionalModule/getAdditionalData', {
            id_request_type: item,
            id_request: -1
          })
        .then((response) => {
            if (response && response.data) {
              console.log('handleTipoCaso response.data, ', response.data)
              this.additionalDataListTmp = response.data.requestTypeByAddData
            }
            this.$vs.loading.close()
         }).catch(() => {
          this.$vs.loading.close()
        })
      }
    },
    handleApplicative() {
      this.casoHelpDesk = null
    },
    handleHelpDesk() {
      this.casoAplicativoId = null
    },
    handleFilePondInit() {
      //console.log('FilePond has initialized')

      // FilePond instance methods are available on `this.$refs.pond`
    },
    handleFilePondAddFile(error, file) {
      if (error) {
        return
      }
      //console.log('file', file)

      this.myFiles.push(file.file)

    },
    handleFilePondRemoveFile(error, file) {
      if (error) {
        return
      }
      //console.log('file', file)

      this.myFiles.map((item, index) => {
        if (item.name === file.filename) {
          this.myFiles.splice(index, 1)
        }
      })
    },
    updateAdditionalData(id, value) {
      // Or if it's a local copy of store data
      const index = this.additionalDataListTmp.findIndex(item => item.id_req_type_by_add_data === id);
      if (index !== -1) {
        // Create a new array with the updated item
        const updatedList = [...this.additionalDataListTmp];
        updatedList[index] = { ...updatedList[index], value };

        console.log("updatedList", updatedList)
        // Then commit this updated list to your store
        // this.$store.commit('SET_ADDITIONAL_DATA', updatedList);
        this.additionalDataListTmp = updatedList;
      }
    },
    closeSidebar() {
      this.closeSidebarProp()
    },
    onFromChange(selectedDates, dateStr, instance) {
      //this.$set(this.configdateIni, 'minDate', dateStr)
    },
    onToChange(selectedDates, dateStr, instance) {
      //this.$set(this.configdateIni, 'maxDate', dateStr)
    },
    validateEmail(email) {
      const re = '/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/'
      return re.test(String(email).toLowerCase())
    }
  }
}
</script>

<style lang="scss">
.vs-textarea {
  font-size: 1rem;
  color: inherit;
  font-family: sans-serif;
  height: 110px;
  line-height: 1.5;
}
</style>
